<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="TOC"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="TOC"><a href="#/Introduction">Introduction</a></p>
<p class="TOC1"><a href="#/Chapter1">1. The Roaring Twenties</a></p>
<p class="TOC"><span href="#/Chapter2" title="Link target outside of Sample">2. The Depression and Hard Times</span></p>
<p class="TOC"><span href="#/Chapter3" title="Link target outside of Sample">3. The Black Dahlia Murder</span></p>
<p class="TOC"><span href="#/Chapter4" title="Link target outside of Sample">4. Serial Killers in Skid Row</span></p>
<p class="TOC"><span href="#/Chapter5" title="Link target outside of Sample">5. The Night Stalker</span></p>
<p class="TOC"><span href="#/Chapter6" title="Link target outside of Sample">6. The Vienna Woods Killer</span></p>
<p class="TOC"><span href="#/Chapter7" title="Link target outside of Sample">7. The Mysterious Death of Elisa Lam</span></p>
<p class="TOC"><span href="#/Chapter8" title="Link target outside of Sample">8. Hotel Suicide</span></p>
<p class="TOC"><span href="#/Chapter9" title="Link target outside of Sample">9. The Rest of the Story</span></p>
<p class="TOC1"><span href="#/Timeline" title="Link target outside of Sample">Timeline</span></p>
<p class="TOC"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="TOC"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="TOC"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?803d57e0